<template>
  <div>
    <div class="banner">
      <img src="/static/images/banner-aboutus.png" >
    </div>
    <div class="box" id="brief">
      <div class="title">公司简介</div>
      <span class="title-line"></span>
      <div class="company-box width1200 el-row--flex is-justify-center is-align-middle">
        <img src="/static/images/company.png" >
        <div class="company">
          <div class="company-title">成易网运</div>
          <div class="company-detail">杭州晟易网络技术服务有限公司是一家从事互联网网络货运行业特色打造的物流平台企业。成立于2008年5月，公司座落在钱塘江南岸的杭州萧山区市心北路财富中心50楼，注册资本为700万人民币。</div>
          <div class="company-detail">公司致力于帮助中小型物流企业提供TMS运输管理系统、电子政务、WMS仓储管理系统，并针对行业痛点，提供相关的业务及财务方面的技术服务。</div>
          <div class="company-detail">于2020年8月在贵州铜仁取得网络货运平台资质，并于同年11月取得代开增值税发票的资质。</div>
          <div class="company-content el-row--flex is-justify-space-between">
            <div>
              <div>2008</div>
              <div class="company-content-label">成立时间（年）</div>
            </div>
            <div>
              <div>700</div>
              <div class="company-content-label">注册资本（万元）</div>
            </div>
            <div>
              <div>100+</div>
              <div class="company-content-label">服务企业（家）</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="purpose-box" id="culture">
      <div class="width1200 el-row--flex is-justify-space-between">
        <div class="purpose el-row--flex is-align-middle">
          <div class="purpose-img"></div>
          <div>
            <div class="purpose-title">企业使命</div>
            <div class="purpose-sub-title">为客户提供优质服务共同成就物流事业!</div>
          </div>
        </div>
        <div class="purpose el-row--flex is-align-middle">
          <div class="purpose-img"></div>
          <div>
            <div class="purpose-title">经营理念</div>
            <div class="purpose-sub-title">客户至上，诚信经营</div>
          </div>
        </div>
        <div class="purpose el-row--flex is-align-middle">
          <div class="purpose-img"></div>
          <div>
            <div class="purpose-title">团队精神</div>
            <div class="purpose-sub-title">团结协作、开拓创新</div>
          </div>
        </div>
        <div class="purpose el-row--flex is-align-middle">
          <div class="purpose-img"></div>
          <div>
            <div class="purpose-title">用人理念</div>
            <div class="purpose-sub-title">有德有才，破格录用有德无才，培养使用</div>
          </div>
        </div>
      </div>
    </div>
    <div class="box" id="course">
      <div class="title">发展历程</div>
      <span class="title-line"></span>
      <div class="width1200">
        <img class="development" src="/static/images/development.png" >
      </div>
    </div>
    <div class="qualification-box" id="qualification">
      <div class="title">核心资质</div>
      <span class="title-line"></span>
      <swiper :options="qualificationSwiperOptions">
        <swiper-slide>
          <div class="qualification">
            <div class="qualification-bg el-row--flex is-justify-space-between">
              <img src="/static/images/qualification-1.png" >
              <div>
                <div class="qualification-title">晟易仓储管理系统</div>
                <div class="qualification-sub-title">【简称：晟易WMS V2.0】</div>
              </div>
            </div>
            <div class="qualification-sum-title">晟易仓储管理系统【简称：晟易WMS V2.0】</div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="qualification">
            <div class="qualification-bg el-row--flex is-justify-space-between">
              <img src="/static/images/qualification-1.png" >
              <div>
                <div class="qualification-title">晟易仓储管理系统</div>
                <div class="qualification-sub-title">【简称：晟易WMS V2.0】</div>
              </div>
            </div>
            <div class="qualification-sum-title">晟易仓储管理系统【简称：晟易WMS V2.0】</div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
  // import Swiper2, { Pagination, Autoplay } from 'vue-awesome-swiper'
  // Swiper2.use([Pagination, Autoplay])

  export default {
    data() {
      return {
        qualificationSwiperOptions: {
          height: 465,
          loop: true,  //是否循环
          effect: 'coverflow',  //进出动画
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: 'auto',
          longSwipesRatio: 0.2,  //滑动多少就可以滑动
          coverflowEffect: {
            slideShadows: true, // 页面阴影效果
            rotate: 0,// 旋转的角度
            stretch: 500,// 拉伸   图片间左右的间距和密集度
            depth: 100,// 深度   切换图片间上下的间距和密集度
            modifier: .8,// 修正值 该值越大前面的效果越明显
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          }
        }
      }
    }
  }
</script>

<style lang="scss">
  .swiper-container {
    .swiper-slide {
      height: 550px;
      background-color: transparent;
    }

    .swiper-pagination-bullet {
      width: 24px;
      height: 6px;
      border-radius: 0;
      background-color: #37a9ff;
      opacity: 1;

      &.swiper-pagination-bullet-active {
        background-color: #1875f0;
      }
    }
  }

  .title {
    &-line {
      display: inline-block;
      width: 40px;
      height: 4px;
      margin-top: 30px;
      background-color: #0b5bdc;
    }
  }

  .company-box {
    margin: 100px auto 86px;

    .company {
      width: 547px;
      height: 375px;
      padding: 30px 28px;
      text-align: left;
      background-color: #f5f5f5;
      box-sizing: border-box;

      &-title {
        margin-bottom: 20px;
        font-size: 24px;
        font-weight: bold;
        color: #333;
      }

      &-detail {
        margin-top: 16px;
        font-size: 14px;
        color: #333;
      }

      &-content {
        width: 412px;
        margin-top: 34px;
        font-size: 28px;
        font-weight: 900;
        color: #1875f0;
        text-align: center;

        &-label {
          font-size: 13px;
          font-weight: 400;
          color: #666;
        }
      }
    }
  }

  .purpose-box {
    padding: 86px 0 51px;
    background-color: #f5f5f5;

    .purpose {
      text-align: left;

      &-img {
        width: 111px;
        height: 113px;
        margin-right: 7px;
        background-position: top center;
        background-repeat: no-repeat;
      }

      &-title {
        font-size: 20px;
        font-weight: bold;
        color: #000;
      }

      &-sub-title {
        width: 126px;
        margin-top: 15px;
        font-size: 14px;
        color: #666;
      }
    }

    .purpose:nth-child(1) .purpose-img {
      background-image: url('/static/images/icon/icon-purpose-1.png');

      &:hover {
        background-image: url('/static/images/icon/icon-purpose-hover-1.png');
      }
    }

    .purpose:nth-child(2) .purpose-img {
      background-image: url('/static/images/icon/icon-purpose-2.png');

      &:hover {
        background-image: url('/static/images/icon/icon-purpose-hover-2.png');
      }
    }

    .purpose:nth-child(3) .purpose-img {
      background-image: url('/static/images/icon/icon-purpose-3.png');

      &:hover {
        background-image: url('/static/images/icon/icon-purpose-hover-3.png');
      }
    }

    .purpose:nth-child(4) .purpose-img {
      background-image: url('/static/images/icon/icon-purpose-4.png');

      &:hover {
        background-image: url('/static/images/icon/icon-purpose-hover-4.png');
      }
    }
  }

  .development {
    margin: 87px auto 68px;
  }

  .qualification-box {
    padding-bottom: 58px;
    background-color: #f5f5f5;

    .qualification {
      width: 541px;
      height: 425px;
      margin: 88px auto 40px;
      box-shadow: 0px 2px 10px 0px rgba(198, 198, 198, 0.3);

      &-bg {
        height: 323px;
        padding: 51px 48px 21px 59px;
        background-image: url('/static/images/bg-quafilication.png');
        box-sizing: border-box;
      }

      &-title {
        margin-top: 40px;
        font-size: 29px;
        font-weight: bold;
        color: #fff;
      }

      &-sub-title {
        margin-top: 15px;
        font-size: 16px;
        color: #fff;
      }

      &-sum-title {
        padding: 40px 5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/aboutus.vue